import React, { useState, useEffect } from "react";
import { Grid, Box, Tabs, Tab, Typography } from "@mui/material";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../context";
import { getAccess } from "../../../../permissions/Permissions";

const PatientList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const user = auth?.user;
  const permissions = getAccess(user?.user?.permissions, user?.user?.isAdmin);

  // Determine the initial tab based on the current pathname.
  const getInitialTab = () => {
    if (location.pathname.includes("ht-patient-view")) return 1;
    if (location.pathname.includes("beauty-patient-view")) return 2;
    if (location.pathname.includes("dental-patient-view")) return 3;
    return 0;
  };

  const [selectedTab, setSelectedTab] = useState(getInitialTab());

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
    // Navigate to the respective route based on the selected tab index.
    if (newValue === 0) {
      navigate("/call-center/view-procedure/call-center/dashboard");
    } else if (newValue === 1) {
      navigate("/call-center/view-procedure/call-center/ht-patient-view");
    } else if (newValue === 2) {
      navigate("/call-center/view-procedure/call-center/beauty-patient-view");
    } else if (newValue === 3) {
      navigate("/call-center/view-procedure/call-center/dental-patient-view");
    }
  };

  return (
    <Grid container spacing={2} sx={{ padding: { xs: 2, md: 4 } }}>
      {/* Header */}
      <Grid item xs={12}>
        <Box
          sx={{
            background: "linear-gradient(135deg, #4caf50 0%, #81c784 100%)",
            padding: { xs: "20px", md: "30px" },
            borderRadius: 2,
            boxShadow: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h3" color="white" fontWeight="bold">
            {t("call_center.patientsListDashboard")}
          </Typography>
          <Typography variant="subtitle1" color="white" sx={{ mt: 1 }}>
            {t("call_center.patientsListSubtitle")}
          </Typography>
        </Box>
      </Grid>

      {/* Tabs Options */}
      <Grid item xs={12}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "background.paper",
            borderRadius: 1,
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            centered
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab
              style={{ textTransform: "capitalize", fontWeight: "bold" }}
              label={t("call_center.dashboard", "Dashboard")}
            />

            {(permissions?.is_staff ||
              (permissions?.is_manager_in_call_center &&
                !permissions?.call_center_admin)) && (
              <Tab
                style={{ textTransform: "capitalize", fontWeight: "bold" }}
                label={t("call_center.htPatientList")}
              />
            )}

            {(permissions?.is_staff ||
              (permissions?.is_manager_in_call_center &&
                !permissions?.call_center_admin)) && (
              <Tab
                style={{ textTransform: "capitalize", fontWeight: "bold" }}
                label={t("call_center.beauty")}
              />
            )}

            {/* {(permissions?.is_staff ||
              permissions?.is_manager_in_call_center ||
              permissions?.call_center_admin) && (
              <Tab
                style={{ textTransform: "capitalize", fontWeight: "bold" }}
                label={t("call_center.dental")}
              />
            )} */}
          </Tabs>
        </Box>
      </Grid>

      {/* Outlet for showing each category's content */}
      <Grid item xs={12}>
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default PatientList;
